/**
 * Created by pajicv on 10/25/18.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import OverlayLevel1 from './OverlayLevel1';
import OverlayLevel2 from './OverlayLevel2';
import CyclesOverlay from './CyclesOverlay.enhancer';
import TaskOverlay from './TaskOverlay';
import TaskOverlayWorker from './TaskOverlayWorker';
import { withStyles } from '@material-ui/core';
import { MANAGER_ROLE, WORKER_ROLE, CO_MANAGER_ROLE } from '../../utils/constants';
import { deleteCycle } from '../../firebase/db/cycle';

const styles = theme => ({
    paper: {
        background: '#fff',
        width: '96%',
        position: 'absolute',
        top: 200,
        bottom: 5,
        left: '2%'
    },
    paperCollapsed: {
        width: '96%',
        position: 'absolute',
        bottom: 5,
        left: '2%'
    },
    container: {
        width: '100%',
        height: '100%',
        overflow: 'auto'
    },
    overlay: {
        opacity: 0,
        backgroundColor: '#000',
        position: 'fixed',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%',
        textAlign: 'center',
        zIndex: 150
    }
});

class OverlayContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            role: props.role,
            selectedCycle: props.cycleId,
            selectedTask: props.taskId,
            taskOverlayCollapsed: false,
            taskDocumentTagsOpened: false
        };
        this.overlayLevel1 = React.createRef();
    }

    handleCycleSelect = (selectedCycle) => {
        this.setState({ selectedCycle });
    };

    handleTaskSelect = (selectedTask) => {
        this.setState({ selectedTask, taskOverlayCollapsed: false });
    };

    handleClickOutsideOverlay1 = () => {
        const { onOverlayClose } = this.props;
        this.setState({ selectedCycle: null, selectedTask: null, taskOverlayCollapsed: false });
        onOverlayClose();
    };

    handleClickOnBackground = (e) => {
        //console.log(ReactDOM.findDOMNode(this.overlayLevel1.current));
        const { onOverlayClose } = this.props;
        this.setState({ selectedCycle: null, selectedTask: null, taskOverlayCollapsed: false });
        onOverlayClose();
    };


    handleClickOutsideOverlay2 = () => {
        console.log('close overlay 2');
        this.setState({ taskOverlayCollapsed: true });
    };

    handleClickInsideOverlay1 = (e) => {
        //e.preventDefault();
        this.setState({ taskOverlayCollapsed: true });
    };

    handleClose = () => {
        const { onOverlayClose } = this.props;
        this.setState({ selectedCycle: null, selectedTask: null, taskOverlayCollapsed: false });
        onOverlayClose();
    }

    handleCloseTask = () => {
        this.setState({ selectedTask: null, taskOverlayCollapsed: false });
    };

    handleClickInsideOverlay2 = () => {
        this.setState(state => state.taskOverlayCollapsed ? { taskOverlayCollapsed: false } : state.taskOverlayCollapsed);
    };

    handleSubTaskAssigned = (subTaskAssigned) => {
        this.setState({ subTaskAssigned });
    };

    handleTaskDocumentTagsOpened = (taskDocumentTagsOpened) => {
        const { onTagsOpen } = this.props;
        this.setState({ taskDocumentTagsOpened });
        if(onTagsOpen) onTagsOpen(taskDocumentTagsOpened);
    };

    handleDeleteCycle = (cycles) => {
        const { selectedCycle } = this.state;
        const { projectId } = this.props;
        this.setState({ selectedCycle: Object.keys(cycles).filter(cycleId => cycleId !== selectedCycle).pop(), selectedTask: null, taskOverlayCollapsed: false },
            () => deleteCycle(projectId, selectedCycle));
    };

    render() {

        const { props: { classes, projectId, overlayLevel, row, title, onCycleDelete }, state: { selectedCycle, selectedTask, subTaskAssigned, taskOverlayCollapsed, role, taskDocumentTagsOpened } } = this;

        if (role !== WORKER_ROLE) {
            return (
                <div className={classes.page}>
                    {
                        Boolean(selectedTask) && (
                            <OverlayLevel2 selectedTask={selectedTask} taskOverlayCollapsed={taskOverlayCollapsed}
                                onClickOutsideOverlay={this.handleClickOutsideOverlay2}
                                onClickInsideOverlay={this.handleClickInsideOverlay2}
                                disableOnClickOutside={true}
                            >
                                <TaskOverlay projectId={projectId} cycleId={selectedCycle} taskId={selectedTask} subTaskAssigned={this.handleSubTaskAssigned}
                                    taskOverlayCollapsed={taskOverlayCollapsed}
                                    onCloseTask={this.handleCloseTask} onTagsOpen={this.handleTaskDocumentTagsOpened} />
                            </OverlayLevel2>
                        )
                    }
                    {
                        Boolean(selectedCycle) && (
                            <OverlayLevel1
                                open={Boolean(selectedCycle)}
                                onClose={this.handleClose}
                                onClickOutsideOverlay={this.handleClickOutsideOverlay1}
                                onClick={this.handleClickInsideOverlay1}
                                disableOnClickOutside={true}
                                ref={this.overlayLevel1}
                            >
                                <CyclesOverlay
                                    projectId={projectId}
                                    cycleId={selectedCycle}
                                    subTaskAssigned={subTaskAssigned}
                                    onCycleSelect={this.handleCycleSelect}
                                    onTaskSelect={this.handleTaskSelect}
                                    onCycleDelete={this.handleDeleteCycle}
                                />
                            </OverlayLevel1>
                        )
                    }
                    <div className={classes.overlay} onClick={this.handleClickOnBackground} />
                </div>
            );
        }
        else {
            return (
                <div className={classes.page}>
                    {
                        Boolean(selectedTask) && (
                            <React.Fragment>
                                {(overlayLevel === 0) && <div className={classes.overlay} />}
                                <OverlayLevel1
                                    open={Boolean(selectedCycle)}
                                    dontShow={true}
                                    onClickOutsideOverlay={this.handleClickOutsideOverlay1}
                                    disableOnClickOutside={taskDocumentTagsOpened}
                                >
                                    <TaskOverlayWorker projectId={projectId}
                                        cycleId={selectedCycle}
                                        taskId={selectedTask}
                                        row={row}
                                        title={title}
                                        taskOverlayCollapsed={false}
                                        onCloseTask={this.handleClickOutsideOverlay1}
                                                       onTagsOpen={this.handleTaskDocumentTagsOpened}
                                    />
                                </OverlayLevel1>
                            </React.Fragment>
                        )
                    }
                </div>
            );
        }

    }

}

export default withStyles(styles)(OverlayContainer);



// WEBPACK FOOTER //
// ./src/components/Overlay/OverlayContainer.js